import React from "react";
import PresetMenuItem from "./PresetMenuItem";
import {MenuItemStyleProps} from "components/DateRangeDropdown/types";

interface MonthsMenuProps {
    selectedData: string;
    setSelectedData: (label: string) => void;
    menuItemStyle?: MenuItemStyleProps;
}

const MonthsMenu: React.FC<MonthsMenuProps> = ({ selectedData, setSelectedData, menuItemStyle }) => {
    return <PresetMenuItem category="Months" selectedData={selectedData} setSelectedData={setSelectedData} menuItemStyle={menuItemStyle} />;
};

export default MonthsMenu;